import { render } from "./TeamHeader.vue?vue&type=template&id=52c1c1ab&scoped=true"
import script from "./TeamHeader.vue?vue&type=script&lang=js"
export * from "./TeamHeader.vue?vue&type=script&lang=js"

import "./TeamHeader.vue?vue&type=style&index=0&id=52c1c1ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c1c1ab"]])

export default __exports__